import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e4fbddb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message-container"
}

import { hasSlotContent } from "@/utilities/EmptySlotCheck";

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageContainer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(hasSlotContent)(_ctx.$slots.default))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})